import { FunctionComponent } from "react";
import { NEATTData } from "src/utils/types/UserTypes";


interface IFinancialGoalsProps {
    financialGoals: NEATTData['fg']
}

const FinancialGoalsDisplay: FunctionComponent<IFinancialGoalsProps> = ({ financialGoals }) => (
    <div className="w-full">
        <p className="mb-3"><span className="font-medium">Has Dependents:</span> {financialGoals.dependents}</p>
        <p className="mb-3"><span className="font-medium">Experienced Hardships:</span> {financialGoals.experiencedHarships}</p>
        <p className="mb-3"><span className="font-medium">How Did They Hear About Us:</span> {financialGoals.howDidTheyHear}</p>
        <p className="mb-3"><span className="font-medium">Has Money Set Aside:</span> {financialGoals.moneySetAside}</p>
        <p className="mb-3"><span className="font-medium">% Income Toward Housing:</span> {financialGoals.percentIncomeTowardsHousing}</p>
        <p className="mb-3"><span className="font-medium">Primary Goal:</span> {financialGoals.primaryGoal}</p>
        <p className="mb-3"><span className="font-medium">Steps Taken:</span> {financialGoals.stepsToImprove}</p>
        <p className="mb-3"><span className="font-medium">Has Support System:</span> {financialGoals.supportSystem}</p>
        <p className="mb-3"><span className="font-medium">Timeline for Goals:</span> {financialGoals.timeline}</p>
        <p className="mb-3"><span className="font-medium">Upcoming Large Expense:</span> {financialGoals.upcomingLargeExpenses}</p>
        <p className="mb-3"><span className="font-medium">Paying or Recieving Child Support / Alimony:</span> {financialGoals.alimonyOrChildSupport.active}</p>
        {financialGoals.alimonyOrChildSupport.active === 'yes' && (<p className="mb-3"><span className="font-medium">Reason:</span> {financialGoals.alimonyOrChildSupport.type}</p>)}
        <p className="mb-3"><span className="font-medium">Had Major Life Changes:</span> {financialGoals.lifeChanges.active}</p>
        {financialGoals.lifeChanges.active === 'yes' && (<p className="mb-3"><span className="font-medium">Reason:</span> {financialGoals.lifeChanges.type}</p>)}
    </div>
);

export default FinancialGoalsDisplay;